<r1-compass-lib-field-mapping
    [index]="rowIndex()"
    [totalRequiredRows]="1"
    [rowOptionButtons]="[{ value: 'delete', display: 'Delete', show: true }]"
    (clickOption)="onDelete()">
    <r1-compass-lib-field-row [fieldRowWidth]="8">
        <r1-compass-lib-field-field [fieldWidth]="3">
            <mat-form-field class="csv-headers-dropdown">
                <mat-label>CSV Field</mat-label>
                <mat-select
                    (selectionChange)="onSourceFieldNameSelected($event.value)"
                    [formControl]="rowFormGroup().controls.source">
                    @for (header of csvHeaders(); track $index) {
                        <mat-option [value]="header">{{ header }}</mat-option>
                    }
                </mat-select>
                @if (rowFormGroup().controls.source.hasError('required')) {
                    <mat-error>Field is required</mat-error>
                }
            </mat-form-field>
        </r1-compass-lib-field-field>
        @if (rowIndex() === 0) {
            <r1-compass-lib-field-field [fieldWidth]="5">
                <mat-form-field>
                    <!-- For some reason, I could not get this one-off hardcoded field to show up. The hardcoded
                     control would have a value, the @let had a value, and an option was selectable. But looking at the docs,
                     the native control being a native HTML element shows the first option by default. And this field does not
                     actually matter for the form, and this looked right. -->
                    @let uniqueSFField = salesforceUniqueRecommendationFieldTargetOption();
                    <mat-label>Recommendation Field</mat-label>
                    <select matNativeControl [disabled]="true">
                        <option [value]="uniqueSFField.name">
                            {{ uniqueSFField.label }} ({{ uniqueSFField.name }})
                        </option>
                    </select>
                    @if (rowFormGroup().controls.recommendationFieldName.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-field-field>
        } @else {
            <r1-compass-lib-field-field [fieldWidth]="5">
                <mat-form-field>
                    <mat-label>Recommendation Field</mat-label>
                    <mat-select
                        (selectionChange)="onRecommendationFieldNameSelected($event.value)"
                        [formControl]="rowFormGroup().controls.recommendationFieldName">
                        @for (recommendationField of recommendationFields(); track $index) {
                            <mat-option
                                [value]="recommendationField.name"
                                [disabled]="fieldAlreadyInUse(recommendationField)"
                                >{{ recommendationField.label }} ({{ recommendationField.name }})
                            </mat-option>
                        }
                    </mat-select>
                    @if (rowFormGroup().controls.recommendationFieldName.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-field-field>
        }
    </r1-compass-lib-field-row>
</r1-compass-lib-field-mapping>
